import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconSpaceRoomSvg } from "./IconSpaceRoomSvg.mjs";
const IconSpaceRoom = (props) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(Box, { component: IconSpaceRoomSvg, ...iconProps });
};
export {
  IconSpaceRoom
};
